import { Injectable, inject } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { GetMaskinlagEntreprenorerResponseDTO } from "~app/common/models/arbetsorder/maskinlag/GetMaskinlagEntreprenorerResponseDTO";
import { MaskinlagtabInformationDTO } from "~app/common/models/arbetsorder/maskinlag/MaskinlagtabInformationDTO";
import { ScheduleDTO } from "~app/common/models/arbetsorder/maskinlag/ScheduleDTO";
import { ApiClientService } from "~app/common/services/api-client.service";

@Injectable({
    providedIn: "root"
})
export class ArbetsorderMaskinlagService {
    private readonly apiClientService = inject(ApiClientService);

    getMaskinlagtabInfo(arbetsorderId: number, maskinlagId?: number): Promise<MaskinlagtabInformationDTO> {
        const params: any = { arbetsorderId: arbetsorderId };

        if (maskinlagId) {
            params.maskinlagId = maskinlagId;
        }

        return firstValueFrom(this.apiClientService.get<MaskinlagtabInformationDTO>("Planera/GetMaskinlagtabInformation", false, params)
        );
    }

    getNextAvailableSpaceInSchedule(arbetsorderId: number, maskinlagId: number): Promise<ScheduleDTO> {
        const params: any = { arbetsorderId: arbetsorderId,
            maskinlagId: maskinlagId };

        return firstValueFrom(this.apiClientService.get<ScheduleDTO>("Planera/GetNextAvailableSpaceInSchedule", false, params)
        );
    }

    getMaskinlagEntreprenorer(arbetsorderId: number, maskinlagId: number): Promise<GetMaskinlagEntreprenorerResponseDTO> {
        const params: any = { arbetsorderId: arbetsorderId,
            maskinlagId: maskinlagId };

        return firstValueFrom(this.apiClientService.get<GetMaskinlagEntreprenorerResponseDTO>("Planera/GetMaskinlagEntreprenorer", false, params)
        );
    }
}
